// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"20040":"20d6bb02fec47021","73283":"14f901174df20f60","83091":"e6a3d1cf66f0ddf4"}[chunkId] + ".css";
};